<template>
  <div class="scroll-wrapper">
    <div class="certificates-page">
      <div class="certificates-toolbar">
        <el-button type="primary" class="certificates-toolbar__btn" @click="openDialog">Добавить сертификат</el-button>
      </div>

      <div class="certificates-table-shell">
        <el-table :data="certificates" class="certificates-table">
          <el-table-column prop="title" label="Название" min-width="220" />
          <el-table-column prop="amount" label="Номинал" min-width="120" />
          <el-table-column prop="duration_months" label="Срок (мес)" min-width="120" />
          <el-table-column prop="comment" label="Комментарий" min-width="220" />
          <el-table-column label="Действия" width="120" align="center">
            <template #default="scope">
              <div class="certificates-actions">
                <el-button size="small" :icon="EditPen" circle @click="editCertificate(scope.row)" />
                <el-button size="small" :icon="Delete" type="danger" circle @click="deleteCertificateAction(scope.row)" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="certificates-mobile-list">
        <div class="certificates-mobile-head">
          <span class="certificates-mobile-head__cell certificates-mobile-head__cell--title">Сертификат</span>
          <span class="certificates-mobile-head__cell certificates-mobile-head__cell--amount">Номинал</span>
          <span class="certificates-mobile-head__cell certificates-mobile-head__cell--term">Срок</span>
          <span class="certificates-mobile-head__cell certificates-mobile-head__cell--actions"></span>
        </div>

        <article v-for="cert in certificates" :key="`mobile-cert-${cert.id}`" class="certificates-mobile-row">
          <div class="certificates-mobile-cell certificates-mobile-cell--title">
            <span class="certificates-mobile-title-text">{{ cert.title }}</span>
            <span v-if="cert.comment" class="certificates-mobile-comment">{{ cert.comment }}</span>
          </div>
          <div class="certificates-mobile-cell certificates-mobile-cell--amount">{{ cert.amount }} в‚Ѕ</div>
          <div class="certificates-mobile-cell certificates-mobile-cell--term">{{ cert.duration_months }} мес</div>
          <div class="certificates-mobile-cell certificates-mobile-cell--actions">
            <div class="certificates-actions certificates-actions--mobile">
              <el-button size="small" :icon="EditPen" circle @click="editCertificate(cert)" />
              <el-button size="small" :icon="Delete" type="danger" circle @click="deleteCertificateAction(cert)" />
            </div>
          </div>
        </article>
      </div>

      <el-dialog v-model="dialogVisible" class="certificates-dialog" :title="isEdit ? 'Редактировать сертификат' : 'Новый сертификат'">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="auto" class="certificates-form">
          <el-form-item label="Название" prop="title">
            <el-input v-model="form.title" />
          </el-form-item>
          <el-form-item label="Номинал" prop="amount">
            <el-input-number v-model="form.amount" :min="1" />
          </el-form-item>
          <el-form-item label="Срок действия (мес)" prop="duration_months">
            <el-input-number v-model="form.duration_months" :min="1" />
          </el-form-item>
          <el-form-item label="Комментарий">
            <el-input v-model="form.comment" type="textarea" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="dialogVisible = false">Отмена</el-button>
          <el-button type="primary" @click="submitForm">Сохранить</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Delete, EditPen } from '@element-plus/icons-vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CertificatesList',
  computed: {
    ...mapState('certificates', ['certificates']),
    Delete() {
      return Delete
    },
    EditPen() {
      return EditPen
    }
  },
  data() {
    return {
      dialogVisible: false,
      isEdit: false,
      form: this.getEmptyForm(),
      editingId: null,
      rules: {
        title: [{ required: true, message: 'Введите название сертификата', trigger: 'blur' }],
        amount: [{ required: true, message: 'Укажите номинал', trigger: 'blur' }],
        duration_months: [{ required: true, message: 'Укажите срок действия', trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapActions('certificates', [
      'fetchCertificates',
      'saveCertificate',
      'updateCertificate',
      'deleteCertificate'
    ]),
    getEmptyForm() {
      return {
        title: '',
        amount: 0,
        duration_months: 12,
        comment: ''
      }
    },
    openDialog() {
      this.form = this.getEmptyForm()
      this.isEdit = false
      this.dialogVisible = true
      this.editingId = null
    },
    editCertificate(cert) {
      this.form = { ...cert }
      this.isEdit = true
      this.editingId = cert.id
      this.dialogVisible = true
    },
    deleteCertificateAction(cert) {
      this.$confirm(
        `Удалить сертификат "${cert.title}"?`,
        'Подтверждение удаления',
        {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          type: 'warning',
        }
      ).then(() => {
        this.deleteCertificate(cert.id)
      }).catch(() => {
        // ничего не делаем при отмене
      })
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (this.isEdit && this.editingId !== null) {
          this.updateCertificate({ id: this.editingId, ...this.form })
        } else {
          this.saveCertificate(this.form)
        }
        this.dialogVisible = false
      })
    }
  },
  mounted() {
    this.fetchCertificates()
  }
}
</script>

<style scoped>
.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

.certificates-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 20px 12px 24px;
  color: var(--cal-text-inverse);
  font-family: var(--ui-font-family-base);
}

.certificates-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
  padding: 0;
}

.certificates-toolbar__btn {
  min-height: 42px;
  padding: 0 18px;
  border-radius: 9px;
  font-family: var(--ui-font-family-base) !important;
  font-size: 18px !important;
  font-weight: 700 !important;
}

.certificates-table-shell {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.certificates-mobile-list {
  display: none;
}

.certificates-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.certificates-mobile-head,
.certificates-mobile-row {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 0.9fr) minmax(0, 0.8fr) 70px;
  gap: 6px;
  align-items: center;
}

.certificates-mobile-head {
  padding: 0 10px 6px;
}

.certificates-mobile-head__cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(174, 194, 230, 0.68);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.certificates-mobile-row {
  min-height: 58px;
  padding: 0 10px;
  background: #0c224b !important;
  box-shadow: inset 0 0 0 1px rgba(74, 106, 173, 0.08) !important;
  border-radius: 12px !important;
}

.certificates-mobile-row + .certificates-mobile-row {
  margin-top: 10px;
}

.certificates-mobile-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d7e7ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 12px;
}

.certificates-mobile-cell--title {
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  text-align: left;
}

.certificates-mobile-title-text,
.certificates-mobile-comment {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.certificates-mobile-title-text {
  color: #22c0ff;
}

.certificates-mobile-comment {
  color: rgba(174, 194, 230, 0.72);
  font-size: 11px;
}

.certificates-mobile-cell--actions {
  justify-content: flex-end;
  overflow: visible;
}

.certificates-actions--mobile {
  gap: 4px;
  width: auto;
  justify-content: flex-end;
}

.certificates-page :deep(.el-table) {
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: transparent;
  --el-table-row-hover-bg-color: transparent;
  --el-table-header-bg-color: transparent;
  --el-table-border-color: transparent;
  --el-table-text-color: var(--cal-text-regular);
  --el-table-header-text-color: var(--cal-text-inverse);
  background: transparent;
  min-width: 800px;
}

.certificates-page :deep(.el-table::before),
.certificates-page :deep(.el-table__inner-wrapper::before) {
  display: none;
}

.certificates-page :deep(.el-table th.el-table__cell),
.certificates-page :deep(.el-table td.el-table__cell) {
  background: transparent;
  border-bottom: 0;
  padding: 0 7px 14px;
}

.certificates-page :deep(.el-table th.el-table__cell .cell) {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(180deg, #15264e 0%, #030b1b 100%) !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 21px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.certificates-page :deep(.el-table td.el-table__cell .cell) {
  min-height: 52px;
  display: flex;
  align-items: center;
  background:
    linear-gradient(180deg, rgba(20, 37, 76, 0.82) 0%, rgba(3, 11, 27, 0.98) 100%) !important;
  box-shadow: inset 0 0 0 1px rgba(24, 49, 97, 0.95) !important;
  border-radius: 8px !important;
  padding: 0 18px !important;
  color: #22c0ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 16px !important;
  line-height: 1 !important;
}

.certificates-page :deep(.el-button--primary:not(.is-plain)) {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}

.certificates-page :deep(.el-button.is-circle) {
  background: #0c224b !important;
  border: none !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  color: #244885 !important;
}

.certificates-page :deep(.el-button.is-circle.el-button--danger) {
  color: #244885 !important;
}

.certificates-page :deep(.el-button.is-circle.el-button--primary:hover) {
  color: #22c0ff !important;
}

.certificates-page :deep(.el-button.is-circle.el-button--danger:hover) {
  color: #ff6b6b !important;
}

.certificates-page :deep(.certificates-dialog.el-dialog) {
  width: min(520px, calc(100vw - 20px)) !important;
  background-color: #10244d !important;
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(90deg, #030b1b 0%, #15264e 100%) !important;
  background-image:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(90deg, #030b1b 0%, #15264e 100%) !important;
  border: 1px solid rgba(44, 86, 163, 0.9) !important;
  box-shadow: 0 28px 80px rgba(0, 6, 19, 0.48) !important;
  border-radius: 0 !important;
}

.certificates-page :deep(.certificates-dialog .el-dialog__header),
.certificates-page :deep(.certificates-dialog .el-dialog__body),
.certificates-page :deep(.certificates-dialog .el-dialog__footer) {
  background: transparent;
}

.certificates-page :deep(.certificates-dialog .el-dialog__header) {
  padding: 14px 16px 0;
}

.certificates-page :deep(.certificates-dialog .el-dialog__body) {
  padding: 10px 16px 14px;
}

.certificates-page :deep(.certificates-dialog .el-dialog__footer) {
  padding: 8px 16px 16px;
}

.certificates-page :deep(.certificates-dialog .el-dialog__title),
.certificates-page :deep(.certificates-dialog .el-form-item__label) {
  color: #ffffff !important;
  font-family: var(--ui-font-family-base) !important;
}

.certificates-page :deep(.certificates-dialog .el-input__wrapper),
.certificates-page :deep(.certificates-dialog .el-input-number),
.certificates-page :deep(.certificates-dialog .el-textarea__inner) {
  background: #07142d !important;
  box-shadow: 0 0 0 1px rgba(48, 87, 154, 0.85) inset !important;
  border: none !important;
}

.certificates-page :deep(.certificates-dialog .el-input-number__decrease),
.certificates-page :deep(.certificates-dialog .el-input-number__increase) {
  background: rgba(15, 34, 72, 0.96) !important;
  color: #22c0ff !important;
  border-color: rgba(77, 120, 198, 0.28) !important;
}

.certificates-page :deep(.certificates-dialog .el-input__inner),
.certificates-page :deep(.certificates-dialog .el-input-number__input),
.certificates-page :deep(.certificates-dialog .el-textarea__inner) {
  color: #22c0ff !important;
  -webkit-text-fill-color: #22c0ff !important;
  font-family: var(--ui-font-family-base) !important;
}

@media (max-width: 768px) {
  .certificates-page {
    padding: 14px 12px 20px;
  }

  .certificates-toolbar {
    justify-content: stretch;
  }

  .certificates-toolbar__btn {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .certificates-table-shell {
    display: block;
  }

  .certificates-mobile-list {
    display: none !important;
  }
}

@media (max-width: 480px) {
  .certificates-page {
    padding: 8px 10px 14px;
  }

  .certificates-page :deep(.el-table) {
    min-width: 860px;
  }

  .certificates-page :deep(.el-table th.el-table__cell),
  .certificates-page :deep(.el-table td.el-table__cell) {
    padding: 0 5px 10px;
  }

  .certificates-page :deep(.el-table th.el-table__cell .cell) {
    min-height: 42px;
    font-size: 14px !important;
  }

  .certificates-page :deep(.el-table td.el-table__cell .cell) {
    min-height: 44px;
    padding: 0 10px !important;
    font-size: 12px !important;
  }

  .certificates-page :deep(.el-button.is-circle) {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
  }
}
</style>

